<template>
  <div class="sidebarbox">
    <div class="leftmenu-box">
      <ul>
        <li v-for="(menu, index) in pagetabs" :key="index" :class="menu.classname">
          <router-link v-if="menu.show" :to="{name: menu.routername, params: {Id: brandid}}">
            {{ menu.menuname }}
          </router-link>
          <router-link v-if="menu.show === false" :to="{name: menu.routername, params: {Id: brandid}}">
            {{ menu.menuname }}
          </router-link>
          <!-- <el-tooltip v-if="menu.show === false" effect="dark" content="暂未开通" placement="top">
            <a class="router-link-disabled">{{ menu.menuname }}</a>
          </el-tooltip> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      brandid: this.$route.params.Id,
      showsellers: false,
      showeinfringements: false,
      pagetabs: [],
      showlists: false,
      isangecy: JSON.parse(localStorage.getItem("userinfo")).val.role == 2 
                || JSON.parse(localStorage.getItem("userinfo")).val.role == 0,
    }
  },

  mounted(){
    this.listStatus()
    this.loadPage()
  },

  methods: {
    
    /**
     * showlists
     */
    listStatus: function(){
      let that = this
      let _objstorage = JSON.parse(localStorage.getItem("price")).val
      let mapobj = _objstorage.filter(item => {
        return item.subid/1 === that.brandid/1
      })
      that.showlists = mapobj[0].tscount == null ? false : true
    },    
    
    /**
     * 加载页面Tab导航
     */
    loadPage: function(){
      let that = this
      let pkglist = JSON.parse(localStorage.getItem("price")).val
      let currentpkg = pkglist.find(o => o.subid/1 === that.brandid/1)
      that.brandid = this.$route.params.Id

      /**
       * 1: 标准版
       * 2：专业版
       * 3：企业版
       * 4：试用版
       */
      that.showsellers = currentpkg.level/1 > 1 ? true : false
      that.showeinfringements = currentpkg.level/1 === 3 ? true : false

      let showimport = that.$route.params.Id * 1 == 121 || 
              that.$route.params.Id * 1 == 173 || 
              that.$route.params.Id * 1 == 178 ||
              that.$route.params.Id * 1 == 247 ||
              that.$route.params.Id * 1 == 257 ||
              that.$route.params.Id * 1 == 269 ||
              that.$route.params.Id * 1 == 216 ||
              that.$route.params.Id * 1 == 281 ||
              (that.$route.params.Id * 1 == 208 && that.isangecy) ? true : false

      let showtestbuy = that.$route.params.Id == 230 || 
              that.$route.params.Id == 231 || 
              that.$route.params.Id == 232 ||
              that.$route.params.Id == 196 ||
              that.$route.params.Id == 190 ||
              that.$route.params.Id == 173 ||
              that.$route.params.Id == 317 ? true : false
      
      // 价格监控
      let menu1 = {
        classname: 'tab-jgjk-link',
        routername: this.$route.path.indexOf('SPU') != -1 ? 'SPUPriceMonitoringProduct' : 'PriceMonitoringProduct',
        menuname: this.$t("SidebarMenu.Menu06"),
        show: true
      }

      // 卖家分析
      let menu2 = {
        classname: 'tab-mjfx-link',
        routername: this.$route.path.indexOf('SPU') != -1 ? 'SPUPriceMonitoringSeller' : 'PriceMonitoringSeller',
        menuname: this.$t('DashboardProduct.tablinkseller'),
        show: true
      }

      // 卖家分析 未开通
      let menu21 = {
        classname: 'tab-mjfx-link',
        routername: 'SellerInactive',
        menuname: this.$t('DashboardProduct.tablinkseller'),
        show: false
      }

      // 侵权商品
      let menu3 = {
        classname: 'tab-qqsp-link',
        routername: this.$route.path.indexOf('SPU') != -1 ? 'SPUEcommerceDefenseProduct' : 'EcommerceDefenseProduct',
        menuname: this.$t("SidebarMenu.Menu01"),
        show: true
      }
      
      // 侵权商品 未开通
      let menu31 = {
        classname: 'tab-qqsp-link',
        routername: 'InfringementsInactive',
        menuname: this.$t("SidebarMenu.Menu01"),
        show: false
      }

      // 关键指标
      let menu4 = {
        classname: 'tab-gjzb-link',
        routername: this.$route.path.indexOf('SPU') != -1 ? 'SPUMetrics' : 'Metrics',
        menuname: this.$t("kpi.s1"),
        show: true
      }

      // 关键指标 未开通
      let menu41 = {
        classname: 'tab-gjzb-link',
        routername: 'MetricsInactive',
        menuname: this.$t("kpi.s1"),
        show: false
      }

      // 投诉管理
      let menu5 = {
        classname: 'tab-tsgl-link',
        routername: that.showlists ? 'Takedowns' : 'TakedownsInactive',
        menuname: this.$t("SidebarMenu.Menu97"),
        show: that.showlists
      }

      // 导入管理
      let menu6 = {
        classname: 'tab-upload-link',
        routername: showimport ? 'Import' : 'ImportInactive',
        menuname: this.$t("SidebarMenu.Menu90"),
        show: showimport
      }

      // 促销管理，所有用户都有权限
      let menu7 = {
        classname: 'tab-promotion-link',
        routername: 'Campaign',
        menuname: this.$t("promomgmt.t1"),
        show: true
      }

      // 测买管理
      let menu8 = {
        classname: 'tab-buyer-link',
        routername: showtestbuy ? 'Testbuy' : 'TestbuyInactive',
        menuname: this.$t("SidebarMenu.Menu87"),
        show: showtestbuy
      }

      // 链接状态
      let menu9 = {
        classname: 'tab-linkstatus-link',
        routername: that.$route.params.Id == 173 || that.$route.params.Id == 257 ? 'Linkstatus' : 'LinkstatusInactive',
        menuname: this.$t("SidebarMenu.linkstatus"),
        show: that.$route.params.Id == 173 || that.$route.params.Id == 257 ? true : false
      }
      
      let menulevel1 = [menu1, menu31, menu21, menu4, menu5, menu6, menu7, menu8, menu9]
      let menulevel2 = [menu1, menu31, menu2, menu4, menu5, menu6, menu7, menu8, menu9]
      let menulevel3 = [menu1, menu3, menu2, menu4, menu5, menu6, menu7, menu8, menu9]
      let menulevel4 = [menu1, menu31, menu21, menu4, menu5, menu6, menu7, menu8, menu9]
      let menulevel5 = [menu1, menu31, menu21, menu41, menu5, menu6, menu7, menu8, menu9]
      let menulevel6 = [menu1, menu9]

      if(currentpkg.level/1 === 1){
        that.pagetabs = menulevel1
      }
      if(currentpkg.level/1 === 2){
        that.pagetabs = menulevel2
      }
      if(currentpkg.level/1 === 3){
        that.pagetabs = menulevel3
      }
      if(currentpkg.level/1 === 4){
        that.pagetabs = menulevel4
      }
      if(currentpkg.level/1 === 5 && currentpkg.subid/1 != 257){
        that.pagetabs = menulevel5
      }
      if(currentpkg.level/1 === 5 && currentpkg.subid/1 == 257){
        that.pagetabs = menulevel6
      }
      
    }

  },
}
</script>